import type { ShaderSource } from "./quad-shader";

/**
 * Paired accumulation shaders adapted from the donor's
 * src/progressiveaa/shaders/accumulation.ts at revision
 * 99958e178f0271cd7a8d82416b6c9c175140b035 (ISC-licensed).
 *
 * The configurator retains its own ping-pong lifecycle and blend-factor
 * contract; only the backend-compatible shader sources are shared here.
 */
export const BLEND_SHADER: ShaderSource = {
	glsl: `
		uniform sampler2D uColorBuffer;
		uniform sampler2D uAccumBuffer;
		uniform float uBlendFactor;
		varying vec2 uv0;

		void main() {
			vec4 current = texture2D(uColorBuffer, uv0);
			vec4 accum = texture2D(uAccumBuffer, uv0);
			gl_FragColor = mix(current, accum, uBlendFactor);
		}`,
	wgsl: `
		var uColorBuffer: texture_2d<f32>;
		var uColorBufferSampler: sampler;
		var uAccumBuffer: texture_2d<f32>;
		var uAccumBufferSampler: sampler;
		uniform uBlendFactor: f32;
		varying uv0: vec2f;

		@fragment fn fragmentMain(input: FragmentInput) -> FragmentOutput {
			var output: FragmentOutput;
			let current = textureSample(uColorBuffer, uColorBufferSampler, uv0);
			let accum = textureSample(uAccumBuffer, uAccumBufferSampler, uv0);
			output.color = mix(current, accum, uniform.uBlendFactor);
			return output;
		}`,
};

export const COPY_SHADER: ShaderSource = {
	glsl: `
		uniform sampler2D uTexture;
		varying vec2 uv0;

		void main() {
			gl_FragColor = texture2D(uTexture, uv0);
		}`,
	wgsl: `
		var uTexture: texture_2d<f32>;
		var uTextureSampler: sampler;
		varying uv0: vec2f;

		@fragment fn fragmentMain(input: FragmentInput) -> FragmentOutput {
			var output: FragmentOutput;
			output.color = textureSample(uTexture, uTextureSampler, uv0);
			return output;
		}`,
};
